<template>
  <div class="form-group">
    <label v-html="question.statement"></label>
    <div class="row" v-for="(itemRow, rowIndex) in question.itemsRows">
      <h4 class="col-xs-12 text-muted" v-html="itemRow.label"></h4>
        <template v-for="(field, fieldIndex) in itemRow.fields">
          <div class="col-xs-12 col-md-6 col-lg-4">
            <component
              v-bind:key="field.uuid"
              ref="fields"
              v-on:fieldUpdated="onFieldUpdated"
              :is="getFieldComponent(field)"
              :field="field"
              :fieldAnswer="getFieldAnswer(itemRow, field)"
              :isDisabled="disabledAttribute"
            >
            </component>
          </div>
        </template>
    </div>
  </div>
</template>

<script>
import CNPJField from './fields/CNPJField'
import StringField from './fields/StringField'
import YearField from './fields/YearField'
import EmailField from './fields/EmailField'
import PhoneNumberField from './fields/PhoneNumberField'
import MultipleChoiceField from './fields/MultipleChoiceField'
import IntegerField from './fields/IntegerField'
import MoneyField from './fields/MoneyField'

export default {
  name: 'ItemsQuestion',
  props: ['question', 'answer', 'isDisabled'],
  data () {
    return {
      m_question: this.question,
      m_answer: {
        questionUuid: this.question.uuid,
        value: this.answer.value ? this.answer.value : []
      },
      m_error: null,
      fieldsPerType: {
        'cnpj': CNPJField,
        'string': StringField,
        'year': YearField,
        'email': EmailField,
        'phone_number': PhoneNumberField,
        'multiple-choice': MultipleChoiceField,
        'integer': IntegerField,
        'money': MoneyField
      }
    }
  },
  mounted () {
    this.sortItemRowsByRenderingOrder(this.question)
    this.sortQuestionFieldsByRenderingOrder(this.question)
  },
  watch: {
    'm_answer.value': {
      handler () {
        this.$emit('answerUpdated', { 'questionUuid': this.question.uuid, 'value': this.m_answer.value })
      },
      deep: true
    }
  },
  computed: {
    disabledAttribute () {
      return this.question.disabled === true || this.isDisabled === true
    }
  },
  methods: {
    sortItemRowsByRenderingOrder (question) {
      question.itemsRows.sort(function (a, b) {
        return a.renderingOrder - b.renderingOrder
      })
      return question
    },
    sortQuestionFieldsByRenderingOrder (question) {
      question.itemsRows.forEach(i => {
        i.fields.sort(function (a, b) {
          return a.renderingOrder - b.renderingOrder
        })
      })
      return question
    },
    getFieldComponent (f) {
      return this.fieldsPerType[f.type]
    },
    onFieldUpdated (itemRowUuid, newFieldAnswer) {
      // Return if already exists
      let fieldAnswer = this.findFieldAnswer(itemRowUuid, newFieldAnswer.fieldUuid)
      if (fieldAnswer) {
        this.copyFieldAnswer(newFieldAnswer, fieldAnswer)
        return
      }

      // Check if the itemRowAnswer already exists in the answer value
      if (!this.hasItemRowAnswer(itemRowUuid)) {
        this.m_answer.value.push({ itemRowUuid: itemRowUuid, fieldsAnswers: [] })
      }

      this.findItemRowAnswer(itemRowUuid).fieldsAnswers.push(newFieldAnswer)
    },
    findFieldAnswer (itemRowUuid, fieldUuid) {
      for (let itemRowAnswer in this.m_answer.value) {
        if (this.m_answer.value[itemRowAnswer].itemRowUuid === itemRowUuid) {
          for (let fieldAnswer in this.m_answer.value[itemRowAnswer].fieldsAnswers) {
            if (
              this.m_answer.value[itemRowAnswer].fieldsAnswers[fieldAnswer] &&
              this.m_answer.value[itemRowAnswer].fieldsAnswers[fieldAnswer].fieldUuid === fieldUuid
            ) {
              return this.m_answer.value[itemRowAnswer].fieldsAnswers[fieldAnswer]
            }
          }
        }
      }
    },
    copyFieldAnswer (fromAnswer, toAnswer) {
      toAnswer.fieldUuid = fromAnswer.fieldUuid
      toAnswer.value = fromAnswer.value
    },
    hasItemRowAnswer (itemRowUuid) {
      for (let itemRowAnswer in this.m_answer.value) {
        if (this.m_answer.value[itemRowAnswer].itemRowUuid === itemRowUuid) {
          return true
        }
      }
      return false
    },
    findItemRowAnswer (itemRowUuid) {
      for (let itemRowAnswer in this.m_answer.value) {
        if (this.m_answer.value[itemRowAnswer].itemRowUuid === itemRowUuid) {
          return this.m_answer.value[itemRowAnswer]
        }
      }
    },
    getFieldAnswer (itemRow, field) {
      for (let itemRowAnswer in this.m_answer.value) {
        if (this.m_answer.value[itemRowAnswer].itemRowUuid === itemRow.itemRowUuid) {
          for (let fieldAnswer in this.m_answer.value[itemRowAnswer].fieldsAnswers) {
            if (this.m_answer.value[itemRowAnswer].fieldsAnswers[fieldAnswer].fieldUuid === field.uuid) {
              return { 'rowIndex': itemRow.itemRowUuid, 'value': this.m_answer.value[itemRowAnswer].fieldsAnswers[fieldAnswer].value }
            }
          }
        }
      }

      return { 'rowIndex': itemRow.itemRowUuid, 'value': null }
    },
    isValid () {
      let areFieldAnswersBlank = true
      for (let itemRowAnswer in this.m_answer.value) {
        for (let fieldAnswer in this.m_answer.value[itemRowAnswer].fieldsAnswers) {
          if (this.m_answer.value[itemRowAnswer].fieldsAnswers[fieldAnswer].value) {
            areFieldAnswersBlank = false
          }
        }
      }

      if (!this.question.required && areFieldAnswersBlank) {
        this.rows = []
        return true
      }

      let areFieldAnswersValid = true
      this.$refs.fields.forEach(f => {
        if (!f.isValid()) {
          areFieldAnswersValid = false
        }
      })

      return areFieldAnswersValid
    }
  }
}
</script>



// WEBPACK FOOTER //
// ItemsQuestion.vue?d13bf560